import { handleResponse, handleError, authHeader } from "./apiUtils";
import axios from "axios";
import { API_ROOT } from "./api-config";

const base = API_ROOT + "ou/";

export function getOU() {
  return axios({
    method: "GET",
    url: base + "GetAllOU",
    headers: authHeader()
  })
    .then(handleResponse)
    .catch(handleError);
}

export function getOUCode() {
  return axios({
    method: "GET",
    url: base + "GetOUCode",
    headers: authHeader()
  })
    .then(handleResponse)
    .catch(handleError);
}
